import { Target, Users, Award, Heart } from 'lucide-react';

export default function AboutUs() {
  return (
    <div className="about-us-page">
      <div className="about-us-container">
        {/* Header */}
        <div className="about-us-header">
          <h1>About Us</h1>
          <p>Learn more about our story, mission, and values.</p>
        </div>

        {/* Story Section */}
        <section className="about-us-section">
          <h2>Our Story</h2>
          <p>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
          </p>
          <p>
            Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
          </p>
        </section>

        {/* Values Grid */}
        <section className="about-us-values">
          <h2>Our Values</h2>
          <div className="about-us-values-grid">
            <div className="about-us-value-card">
              <Target className="about-us-value-icon" />
              <h3>Mission Driven</h3>
              <p>We are committed to delivering excellence in everything we do.</p>
            </div>

            <div className="about-us-value-card">
              <Users className="about-us-value-icon" />
              <h3>Customer First</h3>
              <p>Our customers are at the heart of every decision we make.</p>
            </div>

            <div className="about-us-value-card">
              <Award className="about-us-value-icon" />
              <h3>Quality Focused</h3>
              <p>We never compromise on quality and craftsmanship.</p>
            </div>

            <div className="about-us-value-card">
              <Heart className="about-us-value-icon" />
              <h3>Passionate</h3>
              <p>We love what we do and it shows in our products.</p>
            </div>
          </div>
        </section>

        {/* Team Section */}
        <section className="about-us-section">
          <h2>Our Team</h2>
          <p>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris.
          </p>
        </section>
      </div>
    </div>
  );
}